import produce from 'immer';

export const initialState = {
  isShellV2: false,
};

/* eslint-disable default-case, no-param-reassign */
const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case 'SET_IS_SHELL_V2': {
        draft.isShellV2 = action.payload;
        break;
      }
      case 'SET_FEATURE_FLAGS': {
        draft.featureFlags = action.payload;
        break;
      }
    }
  });

export default reducer;
